import { defineMessages } from "react-intl";

import {
	fibrosisStageMessages,
	steatosisGradeMessages,
	validator
} from "lib/build/forms/ltx/phase-i/consultations/liverElastography";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	liverElastography: {
		id: "form.liver_elastography",
		defaultMessage: "Elasztográfia"
	},
	fibrosisStage: {
		id: "form.liver_elastography.fibrosis_stage",
		defaultMessage: "Fibrózis stádium"
	},
	steatosisGrade: {
		id: "form.liver_elastography.steatosis_grade",
		defaultMessage: "Steatosis fokozat"
	},
	comment: {
		id: "form.liver_elastography.comment",
		defaultMessage: "Megjegyzés"
	}
});

const fields: { [key: string]: FieldData } = {
	fibrosisStage: {
		type: "field",
		path: ["fibrosisStage"],
		label: messages.fibrosisStage,
		errorMessages: genericErrorMessages,
		input: {
			type: "button-group",
			props: { labels: fibrosisStageMessages }
		}
	},
	steatosisGrade: {
		type: "field",
		path: ["steatosisGrade"],
		label: messages.steatosisGrade,
		errorMessages: genericErrorMessages,
		input: {
			type: "button-group",
			props: { labels: steatosisGradeMessages }
		}
	},
	comment: {
		type: "field",
		path: ["comment"],
		label: messages.comment,
		errorMessages: genericErrorMessages,
		input: { type: "textarea", props: {} }
	}
};

const fieldset: FieldsetData = {
	rows: [
		{ columns: [{ width: 12, field: fields.fibrosisStage }] },
		{ columns: [{ width: 12, field: fields.steatosisGrade }] },
		{ columns: [{ width: 12, field: fields.comment }] }
	]
};

export const node: LeafNode = {
	id: "liverElastography",
	value: {
		title: messages.liverElastography,
		validator,
		fieldset
	}
};
